import _ from 'lodash';
import React from 'react';

function BrowseByLetter({
  allData = [],
  emptyTerms = [],
  title = '',
  belowLinkText = ''
}) {
  const alphabets = [...Array(26).keys()].map(i => String.fromCharCode(i + 65));
  const renderAllDrugClasses = allDrug => {
    return (
      !_.isEmpty(allDrug) &&
      allDrug.map((item, index) => {
        return (
          !_.isEmpty(item.elements) && (
            <div
              id={item.letter.toUpperCase()}
              className="alphabetContent"
              key={index}
            >
              <h3 className="alphabetLetter">{item.letter.toUpperCase()}</h3>
              <ul className="drugdName">
                {!_.isEmpty(item.elements) &&
                  item.elements.map((element, i) => {
                    return (
                      <li id={element.slug} key={i}>
                        <a href={`/conditions/${element.slug}`}>
                          {element.title}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
          )
        );
      })
    );
  };
  const executeScroll = (e, elementId) => {
    e.preventDefault();
    document
      .getElementById(elementId)
      .scrollIntoView({ block: 'start', behavior: 'smooth' });
  };
  const handleScroll = elementId => {
    if (typeof window !== 'undefined') {
      const pathName = window.location?.pathname || '';
      window.history.pushState(
        {},
        `${pathName.split('/')[1]}${elementId}`,
        `${pathName}#${elementId}`
      );
    }
    document
      .getElementById(elementId)
      .scrollIntoView({ block: 'start', behavior: 'smooth' });
    _.setFocusWithoutReload(`#${elementId}`, 'a');
  };
  return (
    <div className="wrapperLletter">
      <h2>{title} by letter:</h2>
      <ul className="alphabet">
        {alphabets.map((alphabet, index) =>
          !emptyTerms.includes(alphabet) ? (
            <li key={index}>
              <a
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    handleScroll(alphabet);
                  }
                }}
                href={`#${alphabet}`}
                key={alphabet}
                onClick={e => executeScroll(e, alphabet)}
              >
                {alphabet}
              </a>
            </li>
          ) : (
            <li key={index}>
              <span key={alphabet}>{alphabet}</span>
            </li>
          )
        )}
      </ul>
      <p>{belowLinkText}</p>
      {renderAllDrugClasses(allData)}
    </div>
  );
}

export default BrowseByLetter;
